import { AuthService } from 'phoenix/services';
import { 
	Task,
	TaskResult,
	TaskStatus
} from 'sharebase/domain';
import {
	ColumnType,
	GridInitSort,
	GridConfig
} from 'sharebase/components/grid/grid';

require('./tasks-grid.styles');

export enum SortableColumns {
  targetObjectName = 'targetObjectName',
  creatorName = 'creatorName',
  assignee = 'assignee',
  dateAssigned = 'dateAssigned',
  dateCompleted = 'dateCompleted',
  status = 'status',
  dueDate = 'dueDate'
}

const template = require('./tasks-grid.template');

export class TasksGrid implements ng.IComponentController {
	public static $inject = [
		'$state',
		'pxAuthService',
		'gettextCatalog'
	];

	constructor(
		private $state:ng.ui.IStateService,
		private pxAuthService:AuthService,
		private gettextCatalog:ng.gettext.gettextCatalog
	) {
	}

	public initSort:GridInitSort;

	public config:GridConfig = {
		actionLabel: true,
		hasAvatar: true,
		maxHeight: 200,
		virtualize: false,
		initSort: this.initSort
	}

	public columns = [{
		label: this.gettextCatalog.getString('Task'),
		sortColumn: SortableColumns.targetObjectName,
		type: ColumnType.Text,
		sortable: true
	}, {
		label: this.gettextCatalog.getString('Creator'),
		sortColumn: SortableColumns.creatorName,
		type: ColumnType.Text,
		sortable: true,
		width: '200',
		validator: (tasks:Task[]) => tasks.some(task => task.creatorId !== this.pxAuthService.userId)
	}, {
		label: this.gettextCatalog.getString('Assignee'),
		sortColumn: SortableColumns.assignee,
		type: ColumnType.Text,
		sortable: true,
		width: '200',
		validator: (tasks:Task[]) => tasks.some(task => task.assigneeId !== this.pxAuthService.userId)
	}, {
		label: this.gettextCatalog.getString('Status'),
		sortColumn: SortableColumns.status,
		type: ColumnType.Text,
		sortable: true,
		width: '150',
		validator: (tasks:Task[]) => tasks.some(task => !task.isOpen)
	}, {
		label: this.gettextCatalog.getString('Date Assigned'),
		sortColumn: SortableColumns.dateAssigned,
		type: ColumnType.Date,
		sortable: true,
		width: '200'
	}, {
		label: this.gettextCatalog.getString('Due Date'),
		sortColumn: SortableColumns.dueDate,
		type: ColumnType.Date,
		sortable: true,
		width: '165',
		validator: (tasks:Task[]) => tasks.some(task => task.isOpen)
	}, {
		label: this.gettextCatalog.getString('Date Resolved'),
		sortColumn: SortableColumns.dateCompleted,
		type: ColumnType.Date,
		sortable: true,
		width: '200',
		validator: (tasks:Task[]) => tasks.some(task => !task.isOpen)
	}];
	
	public transform = (task:Task) => {
		return {
			type: task.type,
			icon: 'check',
			data: {
				targetObjectName: {
					text: task.targetObjectName,
					subtext: task.instructions
				},
				creatorName: { text: task.creatorName },
				dueDate: { text: task.dueDate },
				status: { text: this.resolveStatus(task) },
				assignee: { text: task.assigneeName },
				dateCompleted: { text: task.dateEnded },
				dateAssigned: { text: task.dateAssigned }
			},
			source: task,
			isDisabled: task.isDocumentShareExpired,
			trigger: () => this.$state.go('content.myFiles.document', { 'docID': task.targetId })
		}
	}

	private resolveStatus(task:Task) {
		switch(task.status) {
			case TaskStatus.Open:
				return this.gettextCatalog.getString('Open');
			case TaskStatus.Cancelled:
				return this.gettextCatalog.getString('Cancelled');
			case TaskStatus.Expired:
				return this.gettextCatalog.getString('Expired');
			default:
				return task.result === TaskResult.Positive ? this.gettextCatalog.getString('Approved') : this.gettextCatalog.getString('Denied');
		}
	}
	
}

export const TasksGridComponent:ng.IComponentOptions = {
	template: template,
	controller: TasksGrid,
	controllerAs: 'vm',
	bindings: {
		source: '<',
		actions: '<',
		emptyState: '<',
		initSort: '<'
	}
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/tasks-grid/tasks-grid.ts